/* unplugin-vue-components disabled */import { render } from "./NineFlashingBoard.vue?vue&type=template&id=7fb44f28&scoped=true"
import script from "./NineFlashingBoard.vue?vue&type=script&lang=js"
export * from "./NineFlashingBoard.vue?vue&type=script&lang=js"

import "./NineFlashingBoard.vue?vue&type=style&index=0&id=7fb44f28&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb44f28"]])

export default __exports__